import { Button } from '@/components/ui/button'
import { useState } from 'react'
import BulkSetStatusDialog from './BulkSetStatusDialog'

const BulkSetStatusButton = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button variant='outline' onClick={() => setOpen(true)}>
        Bulk set status
      </Button>
      <BulkSetStatusDialog open={open} onOpenChange={setOpen} />
    </>
  )
}

export default BulkSetStatusButton
